<template>

    <v-card>
        <v-card-title>Email Preview</v-card-title>

        <v-divider></v-divider>

        <v-card-text style="height: 800px; padding: 0px;">

            <v-stepper class="stepper" v-model="currentStep" elevation="0">
                <v-stepper-header>
                    <v-stepper-step class="stepper-step" step="1" :complete="currentStep > 1" editable :color="'#c42111'" :rules="[]">Select Alarm</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step class="stepper-step" step="2" :complete="currentStep > 2" editable :color="'#c42111'" :rules="[]">Email Preview</v-stepper-step>
                </v-stepper-header>
                
                <v-stepper-items class="stepper-content-container">
                    <v-stepper-content :step="1" class="stepper-content" style="padding: 0px; margin-top: -10px;">
                        <div class="alarms-container">
                            <alarms-list :alarms="$store.state.alarmsList" :alarmGridResources="alarmGridResources" eid="ag-grid-email-builder-alarms-container" :disableActions="true" :dblClickFunc="alarmSelected" />
                        </div>
                    </v-stepper-content>
                    <v-stepper-content :step="2" class="stepper-content" style="padding: 0px;">
                        <div class="px-6 pt-6">
                            <v-text-field label="Subject" color="#c42111" outlined v-model="processedSubject" readonly />
                            <p class="mt-4" v-html="processedEmailContent" />
                        </div>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">Close</v-btn>
            <v-btn text @click="sendTestEmail">Send Test Email</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script>
import AlarmsList from "@/components/Alarms/AlarmsList";
export default {
    name: 'EmailBuilderPreview',
    props: ['emailBuilderContent', 'subject'],
    components: {
        AlarmsList
    },
    data: () => ({
        currentStep: 1,
        selectedAlarm: null,

        alarmsReady: false,
        technicianOptions: [],
        localeOptions: [],
        siteTagOptions: [],
        issueTemplates: [],
        issueTemplates: [],
        issueTemplatesSubmenu: [],
        

        processedSubject: null,
        processedEmailContent: null,
        mergeFieldObject: null
    }),

    computed: {
        alarmGridResources: function() {
            return {
                technicianOptions: this.technicianOptions,
                localeOptions: this.localeOptions,
                siteTagOptions: this.siteTagOptions,
                issueTemplates: this.issueTemplates
            };
        }
    },

    methods: {
        getSetFilterResources: function() {
            let route = `${TELSA.apiHost}alarms/historicalresources`;
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.technicianOptions = result.technician_list;
                this.localeOptions = result.locale_list;
                this.siteTagOptions = result.site_group_list.map(s => s.site_group_name);

                // Build the context menu sublist for issue templates
                this.issueTemplatesSubmenu.push({
                    name: "NO TEMPLATE",
                    action: () => this.createIssue(null)
                });
                this.issueTemplates = result.issue_templates_list;
                for(let template of this.issueTemplates) {
                    this.issueTemplatesSubmenu.push({
                        name: template.name,
                        action: () => this.createIssue(template)
                    });
                }

                this.alarmsReady = true;
                TELSA.loading(false);
            });
        },

        alarmSelected(alarm) {
            console.log('alarmSelected: ', alarm);
            this.selectedAlarm = alarm.data;
            this.processMergeFields();
            this.currentStep = 2;
        },

        processMergeFields: function() {
            let processedSubject = this.$props.subject;
            let processedEmailContent = this.$props.emailBuilderContent;
            for (const [key, value] of Object.entries(this.selectedAlarm)) {
                const pattern = new RegExp(`{{${key}}}`, 'g');
                processedSubject = processedSubject.replace(pattern, value);
                processedEmailContent = processedEmailContent.replace(pattern, value);
            }
            this.processedSubject = processedSubject;
            this.processedEmailContent = processedEmailContent;
        },

        sendTestEmail: function() {
            let route = (TELSA.apiHost + "settings/emailbuilder/test");
            TELSA.loading(true);
            return this.$http.post(route, {args: {subject: this.processedSubject, content: this.processedEmailContent}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        }
    },

    created() {
    },

    mounted() {
    }
};
</script>

<style scoped>

    .alarms-container {
        height: 725px;
    }

</style>

<style>

    #ag-grid-email-builder-alarms-container {
        position: relative;
        margin-top: 10px;
        height: 825px;
    }

    #ag-grid-email-builder-alarms-container .ag-row-hover {
        background-color: #c8e6c9 !important;
    }

    #ag-grid-email-builder-alarms-container .ag-row-selected {
        background-color: #0000ff !important;
        color: #ffffff !important;
    }

    .alarm-details-historyremarks .v-input__control {
        height: 100%;
    }
    .alarm-details .v-input__control {
        height: 100%;
    }

    .stepper {
        background: #424242 !important;
    }

</style>
